<template>
  <div class="flex justify-center py-10 px-4">
    <div
      class="bg-white/80 backdrop-blur-xl w-full max-w-5xl rounded-3xl shadow-2xl 
             p-8 flex flex-col gap-8 border border-white/40"
    >
      <!-- MAIN CONTENT: TEXT + PREVIEW SIDE BY SIDE -->
      <div class="flex flex-col md:flex-row gap-8 items-stretch">

        <!-- LEFT TEXT / DESCRIPTION -->
        <div
          class="md:w-4/12 w-full flex flex-col gap-4 text-gray-700 
                 md:justify-center text-center md:text-left"
        >
          <!-- JUDUL ATAS -->
          <h3 class="text-2xl font-extrabold tracking-tight">
            {{
              lang === 'id'
                ? 'E-Book sedang Dibuat'
                : 'The e-book is in progress'
            }}
          </h3>

          <!-- PARAGRAF PENJELASAN -->
          <p class="text-sm leading-relaxed text-justify">
            {{
              lang === 'id'
                ? 'Karena jadwal saya padat (sebenarnya nggak padat-padat amat) tapi masih banyak yang harus diperhatikan, jadi mungkin e-book ini akan sangat lama baru selesai.'
                : 'My schedule is quite full (well, not that full honestly), and there are still many things I need to take care of, so it might take quite a long time before this e-book is actually finished.'
            }}
          </p>

          <!-- BOX INFO -->
          <div
            class="mt-2 text-xs bg-gradient-to-r from-blue-50 via-pink-50 to-yellow-50 
                   border border-gray-200 rounded-xl px-4 py-3 inline-block text-justify"
          >
            <p class="font-semibold mb-1">
              {{
                lang === 'id'
                  ? 'Untuk yang penasaran kelanjutannya:'
                  : 'For those curious about what comes next:'
              }}
            </p>
            <p class="leading-relaxed">
              {{
                lang === 'id'
                  ? 'Untuk yang penasaran kelanjutannya, bisa kok dicoba taruh ke kalender, misalnya pertengahan tahun depan. Mana tahu saat itu e-booknya sudah siap, saya akan kasih sedikit preview kalau memang sudah ada dibuat.'
                  : 'If you are curious about how it continues, you can try putting a reminder in your calendar, for example around the middle of next year. Who knows, by then the e-book might be ready, and I can share a little preview if it is.'
              }}
            </p>
          </div>

          <p class="text-[11px] text-gray-500 mt-3 text-justify">
            {{
              lang === 'id'
                ? 'Catatan: beberapa browser mungkin tetap menampilkan ikon download bawaan di viewer PDF.'
                : 'Note: some browsers may still show their own built-in download icon in the PDF viewer.'
            }}
          </p>
        </div>

        <!-- RIGHT: DIRECT PDF PREVIEW (INLINE, pakai Mozilla PDF.js) -->
        <div class="md:w-8/12 w-full">
          <div
            class="w-full h-[380px] md:h-[500px] rounded-2xl overflow-hidden 
                   shadow-2xl border border-gray-300 bg-white"
          >
            <!-- IFRAME VIEWER -->
            <iframe
              v-if="viewerURL"
              :src="viewerURL"
              class="w-full h-full"
              frameborder="0"
              loading="lazy"
            ></iframe>

            <!-- FALLBACK JIKA viewerURL BELUM TERSET -->
            <div
              v-else
              class="w-full h-full flex flex-col items-center justify-center 
                     p-4 text-center text-sm text-gray-600"
            >
              <p>
                {{
                  lang === 'id'
                    ? 'Pratinjau PDF tidak dapat dimuat.'
                    : 'The PDF preview could not be loaded.'
                }}
              </p>
              <p class="mt-2">
                {{
                  lang === 'id'
                    ? 'Silakan cek kembali URL atau konfigurasi file PDF-nya.'
                    : 'Please check the URL or the PDF file configuration.'
                }}
              </p>
              <code class="mt-2 text-xs break-all bg-gray-100 px-2 py-1 rounded">
                {{ pdfURL }}
              </code>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopPreview",
  props: {
    lang: {
      type: String,
      default: "id"
    }
  },
  data() {
    return {
      viewerURL: null
    };
  },
  computed: {
    pdfURL() {
      return this.lang === "id"
        ? "/Shop_indo.pdf"
        : "/Shop_english.pdf";
    }
  },
  methods: {
    updateViewer() {
      if (typeof window === "undefined") return;

      // absolute URL ke PDF
      const absolutePdfURL = new URL(this.pdfURL, window.location.origin).href;

      // URL ke PDF.js viewer Mozilla
      this.viewerURL =
        "https://mozilla.github.io/pdf.js/web/viewer.html?file=" +
        encodeURIComponent(absolutePdfURL);
    }
  },
  mounted() {
    this.updateViewer();
  },
  watch: {
    // setiap kali lang berubah, update viewer-nya
    lang() {
      this.updateViewer();
    }
  }
};
</script>


<style scoped>
/* style lama .lang-btn dihapus karena sudah tidak dipakai di sini */
</style>
